import { shortDateFormat } from '@zipari/shared-util-common';

export const dateFormat = {
  billPeriod: shortDateFormat,
};
